// React 
import React, { useEffect, useState } from "react";

// Components
import LoadingComponent from "./LoadingComponent";
import Navbar from "./Navbar";
import Filters from "./Filters/Filters";
import store from "../store/Store";
import {dataFetching} from "../store/DataFetch";
import ProductList from "./Product/ProductList";

// Firebase
import { useAuthState } from "react-firebase-hooks/auth";
import {
  auth,
  logout,
} from "../firebase";

import {
  userNotAuthenticated,
  userAuthSuccess,
  userAuthRequest,
  userAuthFailed,
} from "../store/Store"; 

import {useSelector, useDispatch}  from "react-redux";

// Material UI
import { Button, Stack } from '@mui/material';

// react-router-dom
import { Link, useNavigate } from "react-router-dom";

function Home(){

	const [user, loading, error] = useAuthState(auth);
	const navigate = useNavigate() ;
	const dispatch = useDispatch() ;
	const isDataFetched = useSelector((state)=>state.API.isDataFetched);

	useEffect(()=>{
		if(!isDataFetched){
			dataFetching();
		}
	},[isDataFetched]);

	useEffect(()=>{
		if(loading){
			return ;
		}
		if(!user){
			dispatch(userNotAuthenticated());
			navigate("/");
		}
	},[user,loading]);

  useEffect(()=>{
    if(error){
      dispatch(userAuthFailed(error));
      navigate("/");
    }
  },[error]);

	return (
		<>
			{
				user ?
				<>
					<Navbar />

					{
						isDataFetched ? 
							<>
								<Filters />
								<ProductList />
							</>
						 : <LoadingComponent />
					}

				</>
			: <LoadingComponent /> 

			}
		</>
	);
}

export default Home;